<template>
    <div>
        <div class="row">
            <div class="col-md-4 pl-4">
                
            </div>
            <div class="col-md-4 pl-4 text-center">
               <h4 class="text-center text-primary">Process Payroll</h4>
            </div>
            <div class="col-md-4 text-right">
                
            </div>
            
        </div>
        
        <CCard class="p-4">
          <CRow>
            <CCard class="p-4 pl-4 pr-4 ml-2 mr-2 mt-2 col-md-5 payroll-covered-card">
              <div class="payroll-covered-title">Payroll Period Covered</div>
              <hr class="payroll-covered-divider">

              <div class="payroll-date-row">
                <div class="payroll-date-col">
                  <label class="payroll-date-label">From</label>
                  <div class="payroll-date-input-wrap">
                    <Datepicker
                      input-class="form-control bg-white payroll-date-input"
                      v-model="payroll_date_from"
                    >
                    </Datepicker>
                    <i class="fa fa-calendar payroll-date-icon"></i>
                  </div>
                </div>

                <div class="payroll-date-col">
                  <label class="payroll-date-label">To</label>
                  <div class="payroll-date-input-wrap">
                    <Datepicker
                      input-class="form-control bg-white payroll-date-input"
                      v-model="payroll_date_to"
                    >
                    </Datepicker>
                    <i class="fa fa-calendar payroll-date-icon"></i>
                  </div>
                </div>
              </div>

              <div class="text-right mt-3">
                <a
                  href="javascript:void(0)"
                  :class="{'disabled' : !(payroll_date_from && payroll_date_to)}"
                  class="btn btn-primary payroll-generate-btn"
                  @click="generatePayroll"
                >
                  <i class="fa fa-plus mr-1"></i> Generate Payroll
                </a>
              </div>

              <div class="payroll-note-box mt-4">
                <i class="fa fa-info-circle payroll-note-icon"></i>
                <div>
                  <strong class="payroll-note-title">Note</strong>
                  <p class="payroll-note-text mb-0">
                    Please select the payroll period and configure the deduction options before generating payroll.
                  </p>
                  <p v-if="no_data == true" class="text-danger mb-0 mt-1"><em>No data for this selected period.</em></p>
                </div>
              </div>
            </CCard>

            <CCard class="p-4 pl-4 pr-4 ml-2 mr-2 mt-2 col-md-6">
              <CRow>
                <CCol lg="12" class="mt-2">
                  <h5 class="mb-1 mandatory-title">Mandatory Contributions</h5>
                  <p class="text-muted mb-3 mandatory-subtitle">Select the mandatory contributions to include in this payroll run.</p>
                </CCol>
              </CRow>
              <CRow>
                <CCol lg="12">
                  <div class="mandatory-list">
                    <div class="mandatory-item" v-for="item in contributionOptions" :key="item.key">
                      <div class="mandatory-checkbox">
                        <input class="form-check-input" type="checkbox" :id="item.key" v-model="item.checked">
                      </div>
                      <label class="mandatory-content mb-0" :for="item.key">
                        <div class="mandatory-logo" :class="`logo-${item.key}`">{{ item.logoText }}</div>
                        <div class="mandatory-text">
                          <strong class="mandatory-label">{{ item.label }}</strong>
                          <small class="d-block text-muted mandatory-description">{{ item.description }}</small>
                        </div>
                      </label>
                    </div>
                  </div>
                </CCol>
              </CRow>
            </CCard>
        </CRow>
      </CCard>
      
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import moment from 'moment'
export default {
    name : 'step1',
    components: { Datepicker, vSelect },
    filters: {
      formatDate(val) {
        if(val) 
          return moment(val).format('MM/DD/YYYY')
        return '';
      },
    },
    
    props: {
      no_data : {
        type: Boolean,
        default: null
      }
    },
    data() {
      return {
        payroll_date_from : null,
        payroll_date_to : null,
        contributionOptions: [
          {
            key: 'sss',
            label: 'SSS',
            description: 'Social Security System',
            logoText: 'SSS',
            checked: true
          },
          {
            key: 'philhealth',
            label: 'PhilHealth',
            description: 'Philippine Health Insurance Corporation',
            logoText: 'PH',
            checked: true
          },
          {
            key: 'pagibig',
            label: 'Pag-IBIG Contribution',
            description: 'Pag-IBIG Fund Membership Savings',
            logoText: 'HD',
            checked: true
          }
        ]
      }
    },
    mounted() {},
    methods: {
      generatePayroll() {
        const mandatory = {
          sss: this.getContributionChecked('sss'),
          phic: this.getContributionChecked('philhealth'),
          pag_ibig: this.getContributionChecked('pagibig')
        };

        this.$emit('generate', {
          from: this.payroll_date_from,
          to: this.payroll_date_to,
          mandatory
        })
      },
      getContributionChecked(key) {
        const contribution = this.contributionOptions.find((item) => item.key == key);
        return contribution ? contribution.checked : true;
      },
      processPayroll(q) {
        this.$emit('process', q)
      }
    }
    
    
}

</script>

<style scoped>
.payroll-covered-card {
  border: 1px solid #e7edf5;
  border-radius: 8px;
}

.payroll-covered-title {
  font-size: 24px;
  font-weight: 700;
  color: #2c3d56;
}

.payroll-covered-divider {
  border-top: 1px solid #e3e8f0;
  margin: 14px 0 16px;
}

.payroll-date-row {
  display: flex;
  gap: 14px;
}

.payroll-date-col {
  flex: 1;
}

.payroll-date-label {
  display: block;
  margin-bottom: 6px;
  font-size: 15px;
  color: #3a4a63;
  font-weight: 600;
}

.payroll-date-input-wrap {
  position: relative;
}

.payroll-date-input {
  height: 40px;
  border: 1px solid #d6deea;
  border-radius: 6px;
  padding-right: 32px;
}

.payroll-date-icon {
  position: absolute;
  right: 11px;
  top: 50%;
  transform: translateY(-50%);
  color: #627389;
  pointer-events: none;
}

.payroll-generate-btn {
  background: #2f7df4;
  border-color: #2f7df4;
  border-radius: 6px;
  font-weight: 600;
  padding: 8px 14px;
}

.payroll-note-box {
  border: 1px solid #d2def0;
  background: #eef4fd;
  border-radius: 6px;
  display: flex;
  gap: 10px;
  padding: 10px 12px;
}

.payroll-note-icon {
  color: #245fc7;
  margin-top: 3px;
}

.payroll-note-title {
  display: block;
  color: #23457a;
  font-size: 14px;
}

.payroll-note-text {
  color: #2f5a92;
  font-size: 14px;
  line-height: 1.35;
}

.mandatory-title {
  font-weight: 700;
  color: #233147;
}

.mandatory-subtitle {
  font-size: 14px;
}

.mandatory-list {
  border: 1px solid #dde3eb;
  border-radius: 6px;
  overflow: hidden;
  background: #fff;
}

.mandatory-item {
  display: flex;
  align-items: center;
  min-height: 86px;
  border-bottom: 1px solid #e8edf3;
  padding: 0 14px 0 16px;
}

.mandatory-item:last-child {
  border-bottom: none;
}

.mandatory-checkbox {
  width: 26px;
  flex: 0 0 26px;
  margin-top: -2px;
}

.mandatory-checkbox .form-check-input {
  position: static;
  margin-left: 0;
}

.mandatory-content {
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
}

.mandatory-logo {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  margin: 0 14px 0 6px;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 0.3px;
}

.logo-sss {
  background: #1d4f9e;
}

.logo-philhealth {
  background: #2a8a4b;
}

.logo-pagibig {
  background: #0b63c9;
}

.mandatory-text {
  display: flex;
  flex-direction: column;
}

.mandatory-label {
  color: #1f2e47;
  font-size: 18px;
  line-height: 1.2;
}

.mandatory-description {
  margin-top: 2px;
  font-size: 13px;
}
</style>